/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react'
// import { connect } from 'react-redux'
import './Table.scss'
import { Select, Unselect, UnselectAll, SelectAll } from 'redux/store/actions'
import { SelectField } from 'components/Inputs/Inputs'
import sorting from 'assets/images/sorting.svg'
import NoData from 'components/NoData/NoData'
import Pagination from 'components/Pagination/Pagination'
import CN from 'classnames'
import { useTranslation } from 'react-i18next'
// import { DOMElements } from '@chakra-ui/system/dist/declarations/src/system.utils'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'redux/store/reducers'

interface Props {
  indexKey?: string
  tableCustomeStyle?: string
  listName?: string
  radioButton?: boolean
  height?: number
  resizeAutoTableHeight?: number
  elements: any
  onSortingChange?: (e: { sortedBy: string; sortingType: string }) => void
  // pagination?:{totalItems:number , onPaginationChange (e:any) => void}
}
/**
 *  @param indexKey = unique number like id   *require
 *  @param tableHeaders = colum name        *require
 *  @param elements = all data              *require
 *  @param onSortingChange = callBack function to get sorting info *require
 *  @param SelectItems = all selected Selected Items
 *  @param renderCell = if you want to render another component or format value to date
 *  @param width = width colum
 *  @param height =  height table -- send auto if you don't want to calculate the height of the table based on the height of the user screen
 *  @param resizeAutoTableHeight = if you want to to use auto-size table but you want to add or minus table height you can send some px here
 */
export function Table(props: any): JSX.Element {
  const { t } = useTranslation()
  const [state, setState] = useState({ sortedBy: '', sortingType: '' })
  const [calcHight, setCalcHight] = useState(false)
  const dispatch = useDispatch()
  const selectedData = useSelector((state: RootState) => state.Select)

  const indexKeyItem = props.indexKey ? props.indexKey : 'id'
  const { resizeAutoTableHeight = -60, height } = props
  const tableRef = useRef<HTMLHeadingElement | null>(null)

  useEffect(() => {
    // Calculating the height of the table according to the height of the user's screen
    if (!height && tableRef.current) {
      const offsets = tableRef.current.getBoundingClientRect()
      const element = document?.getElementById('root')?.firstChild as Element
      const heightBody = element.getBoundingClientRect()
      tableRef.current.style.height = `${parseFloat(
        `${heightBody.height + resizeAutoTableHeight - offsets.top}`
      ).toFixed(0)}px`
      setCalcHight(true)
    } else {
      setCalcHight(true)
    }
  }, [tableRef, tableRef.current, height])

  const SelectHandle = (selectedItem: any): void => {
    const found = selectedData[props.listName]
      ? selectedData[props.listName].find(
          (item: any) => item[indexKeyItem] === selectedItem[indexKeyItem]
        )
      : null
    if (found) {
      dispatch(Unselect({ listName: props.listName, selectedItem }))
    } else if (props.radioButton) {
      dispatch(UnselectAll({ listName: props.listName }))
      dispatch(Select({ listName: props.listName, selectedItem }))
    } else {
      dispatch(Select({ listName: props.listName, selectedItem }))
    }
  }
  const SelectAllHandle = (): void => {
    if (
      selectedData[props.listName] &&
      props.elements &&
      selectedData[props.listName].length === props.elements.length
    ) {
      dispatch(UnselectAll({ listName: props.listName }))
    } else {
      dispatch(SelectAll({ elements: props.elements, listName: props.listName }))
    }
  }
  const handelSorting = (name: any) => {
    if (state.sortedBy === name) {
      if (state.sortingType === 'ASC') {
        setState({ sortedBy: name, sortingType: 'DESC' })
        props.onSortingChange({ sortedBy: name, sortingType: 'DESC' })
      } else {
        setState({ sortedBy: name, sortingType: 'ASC' })
        props.onSortingChange({ sortedBy: name, sortingType: 'ASC' })
      }
    } else {
      setState({ sortedBy: name, sortingType: 'ASC' })
      props.onSortingChange({ sortedBy: name, sortingType: 'ASC' })
    }
  }

  return (
    <div>
      <div className="TableComponent py-0 overflow-auto	 font-regular  w-full">
        <div
          ref={tableRef}
          id="maxHeightTableComponent"
          style={{
            maxHeight: height ? `${height}px` : 'none',
            overflowY: 'auto',
          }}>
          {calcHight && (
            <div className="relative py-0 m-0 w-full ">
              <div className={`py-0 mx-0 w-full  `} style={{ height: 'auto' }}>
                <table
                  className={`text-center  w-full ${
                    props.tableCustomeStyle ? props.tableCustomeStyle : ''
                  }`}>
                  <thead className="">
                    <tr className="">
                      {props.listName ? (
                        <th className=" p-2 text-sm">
                          {!props.radioButton && (
                            <label className="w-full flex justify-center" htmlFor="radioButton">
                              <input
                                type="checkbox"
                                id="radioButton"
                                onChange={SelectAllHandle}
                                checked={
                                  // eslint-disable-next-line no-nested-ternary
                                  selectedData[props.listName]
                                    ? !!(
                                        selectedData[props.listName].length > 0 &&
                                        selectedData[props.listName].length ===
                                          props.elements?.length
                                      )
                                    : false
                                }
                              />
                            </label>
                          )}
                          {/* <div className=" checkboxContainer  d-block p-0 m-0">
                            <label className=" p-0 m-0" htmlFor="radioButton">
                              <input
                                id="radioButton"
                                type="checkbox"
                                onChange={SelectAllHandle}
                                checked={
                                  // eslint-disable-next-line no-nested-ternary
                                  selectedData[props.listName]
                                    ? !!(
                                        selectedData[props.listName].length > 0 &&
                                        selectedData[props.listName].length === props.elements?.length
                                      )
                                    : false
                                }
                              />
                              <span className="checkmark" />
                            </label>
                          </div> */}
                        </th>
                      ) : null}
                      {props.tableHeaders?.map((header: any, i: any) => (
                        <th
                          key={`${i + 1}-Headers`}
                          className={`${
                            props.headCustomStyle ? props.headCustomStyle : ''
                          } py-1 text-sm text-gray-400 bg-white font-normal `}
                          style={header.width > 1 ? { width: parseFloat(header.width) } : {}}>
                          <div
                            className={CN('flex justify-center', {
                              ' print:hidden': header.title === 'Action',
                            })}>
                            {t(header.title)}
                            {header.sorting && (
                              <button
                                type="button"
                                className="px-1"
                                onClick={() => handelSorting(header.sorting)}>
                                {state.sortedBy === header.sorting ? (
                                  <img
                                    src={sorting}
                                    alt="sorting"
                                    className={
                                      state.sortingType === 'ASC'
                                        ? 'w-2.5  rotate-180 transition-all	duration-150'
                                        : 'w-2.5  transition-all duration-150	'
                                    }
                                  />
                                ) : (
                                  <div className="flex">
                                    <img
                                      src={sorting}
                                      alt="sorting"
                                      className="w-2.5  rotate-180"
                                    />
                                    <img src={sorting} alt="sorting" className="w-2.5  " />
                                  </div>
                                )}
                              </button>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="">
                    {Array.isArray(props.elements) &&
                      props.elements?.map((row: any, i: any) => {
                        return (
                          <tr className="py-1 bg-white  " key={`${i + 1}table`}>
                            {props.listName ? (
                              <td className="py-1 text-sm p-2">
                                {!props.radioButton ? (
                                  <label
                                    className="w-full flex justify-center"
                                    htmlFor="radioButton">
                                    <input
                                      type="checkbox"
                                      id="radioButton"
                                      checked={
                                        // eslint-disable-next-line no-nested-ternary
                                        selectedData[props.listName]
                                          ? !!selectedData[props.listName].filter(
                                              (item: any) =>
                                                item[indexKeyItem] === row[indexKeyItem]
                                            )[0]
                                          : false
                                      }
                                      key={`${row[indexKeyItem]}-checkboxContainer`}
                                      onChange={() => SelectHandle(row)}
                                      className={!props.radioButton ? '  ' : ' rounded-full'}
                                    />
                                  </label>
                                ) : (
                                  <label className=" p-0 m-0 pt-1">
                                    <input
                                      type="radio"
                                      checked={
                                        selectedData[props.listName]
                                          ? !!selectedData[props.listName].filter(
                                              (item: any) =>
                                                item[indexKeyItem] === row[indexKeyItem]
                                            )[0]
                                          : false
                                      }
                                      key={`${row[props.indexKey]}radio-button`}
                                      onChange={() => SelectHandle(row)}
                                    />
                                  </label>
                                )}
                              </td>
                            ) : null}
                            {props.tableHeaders?.map((col: any, index: any) => (
                              <td
                                className={CN('py-2 text-sm ', { 'print:hidden': !row[col.value] })}
                                key={`${index + 1}table-col`}>
                                {col.renderCell ? col.renderCell(row, col) : row[col.value]}
                              </td>
                            ))}
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
                {Array.isArray(props.elements) &&
                  props.elements.length < 1 &&
                  props.loadingCounter < 1 && (
                    <div className="flex justify-center w-full pb-5">
                      <NoData />
                    </div>
                  )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="p-2 ">
        {props.pagination && (
          <Pagination
            totalItems={props.pagination.totalItems}
            onPaginationChange={props.pagination.onPaginationChange}
          />
        )}
      </div>
    </div>
  )
}

// const mapStateToProps = (state: any) => {
//   return {
//     selecteditems: state.Select,
//     loadingCounter: state.Global.loadingCounter,
//   }
// }
// const mapDispatchToProps = {
//   Select,
//   Unselect,
//   UnselectAll,
//   SelectRow,
//   SelectAll,
// }
// export default connect(mapStateToProps, mapDispatchToProps)(Table)
